export function enumerateMethods<T extends object>(instance: T) {
  const methodNames = (
    Object.getOwnPropertyNames(Object.getPrototypeOf(instance)) as (keyof T)[]
  ).filter(
    (name) => name !== 'constructor' && typeof instance[name] === 'function',
  )

  methodNames.forEach((name) => {
    Object.defineProperty(instance, name, {
      value: instance[name],
      enumerable: true,
      configurable: true,
      writable: true,
    })
  })
}
